export default __webpack_public_path__ + "static/media/loading.2115b6bd.gif";